import { supabase } from '../supabase';
import { populateWorkspaceFromTemplate } from '../api';

export async function populateWorkspaceContent() {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (user?.user_metadata?.workspace_populated) return;

  try {
    const result = await populateWorkspaceFromTemplate();
    if (result.skipped && result.reason !== 'already_populated') return;
    await supabase.auth.updateUser({
      data: { workspace_populated: true },
    });
  } catch (err) {
    console.error('Workspace template population failed:', err);
  }
}
